<template>
  <BaseDialog
    :title="displayText.title"
    width="600px"
    :close-on-click-modal="false"
    :btn1="displayText.btn.confirm"
    :btn2="displayText.btn.cancel"
    @close="$emit('close')"
    @cancel="$emit('close')"
    @confirm="onSubmit"
  >
    <main class="select-area">
      <div class="border-b border-gray-40">
        <p class="select-area-title">{{ displayText.sectionTitle }}</p>
      </div>
      <div style="padding: 16px">
        <BaseElCheckboxGroup v-model="selected" class="item-group">
          <div
            v-for="item in displayData.riskLevelOptions"
            :key="item.value"
            class="flex items-center mb-3"
            style="padding-left: 15px"
          >
            <BaseElCheckbox :label="item.value" @change="onRiskLevelCheck($event, item)">
              <span class="flex items-center" style="gap: 8px">
                <span>{{ item.label }}</span>
              </span>
            </BaseElCheckbox>
          </div>
        </BaseElCheckboxGroup>
      </div>
    </main>
  </BaseDialog>
</template>

<script>
import { defineComponent, ref, onMounted, computed } from 'vue'
import { appointmentRiskGuardConfig } from '@/config/appointmentRiskGuard'
import BaseDialog from '@/components/Dialog/BaseDialog.vue'

export default defineComponent({
  name: 'RiskLevelAdvanceSelector',
  components: {
    BaseDialog,
  },
  props: {
    syncData: { type: Array, default: () => [] },
  },
  emits: ['close', 'confirm'],
  setup (props, { emit }) {
    const selected = ref([])
    const riskLevelOptions = appointmentRiskGuardConfig.riskLevelOptions
    const displayText = computed(() => ({
      title: '選擇訂單風險',
      sectionTitle: '選擇訂單風險',
      btn: {
        cancel: '取消',
        confirm: '確認',
      },
    }))
    const displayData = computed(() => ({
      riskLevelOptions: riskLevelOptions,
    }))
    const onRiskLevelCheck = (checked, item) => {
      if (checked) {
        if (!selected.value.includes(item.value)) {
          selected.value.push(item.value)
        }
      } else {
        selected.value = selected.value.filter(value => value !== item.value)
      }
    }

    const onSubmit = () => {
      const selectedItems = riskLevelOptions.filter(item =>
        selected.value.includes(item.value),
      )
      emit('confirm', selectedItems)
      emit('close')
    }

    // 初始化已選中的項目
    onMounted(() => {
      if (props.syncData && props.syncData.length > 0) {
        selected.value = props.syncData.map(item => item.value || item)
      }
    })

    return {
      selected,
      displayText,
      displayData,
      onRiskLevelCheck,
      onSubmit,
    }
  },
})
</script>
<style lang="postcss" scoped>
.select-area {
  @apply border border-gray-40 mt-[12px] rounded-[4px];
}

.select-area-title {
  @apply p-[8px] text-base font-medium text-sub;
}

.item-group {
  @apply flex flex-col;
}

.item-group .el-checkbox {
  @apply mb-2;
}
</style>
